export function groups(state = [], action) {
  const { detail } = action;
  switch (action.type) {
    case 'LOAD_GROUPS':
      return detail;
    default:
      return state;
  }
}
